// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.room-item {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  flex-direction: column;
  min-height: 30px;
}
.room-item .room-item-user {
  height: 40px;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  cursor: grab;
  padding: 0 18px;
}
.room-item .room-item-user:hover {
  background: rgba(82, 82, 128, 0.09);
}
.room-item .room-item-user-color-avatar {
  font-size: 14px;
  color: #fff;
  text-align: center;
  width: 26px;
  height: 26px;
  line-height: 26px;
  box-sizing: border-box;
  padding: 0 5px;
  font-weight: 700;
  margin-right: 8px;
  border-radius: 20%;
}
.room-item .room-item-user-color-avatar.avatar1 {
  background: #27ae60;
}
.room-item .room-item-user-color-avatar.avatar2 {
  background: #16a085;
}
.room-item .room-item-user-color-avatar.avatar3 {
  background: #2980b9;
}
.room-item .room-item-user-color-avatar.avatar4 {
  background: #8e44ad;
}
.room-item .room-item-user-color-avatar.avatar5 {
  background: #34495e;
}
.room-item .room-item-user-color-avatar.avatar6 {
  background: #f39c12;
}
.room-item .room-item-user-color-avatar.avatar7 {
  background: #d35400;
}
.room-item .room-item-user-color-avatar.avatar8 {
  background: #c0392b;
}
.room-item .room-item-user-title {
  flex-grow: 1;
}
.room-item .room-item-user-avatar {
  max-width: 26px;
  max-height: 26px;
  margin-right: 8px;
}
.room-item .room-item-user-name {
  line-height: 30px;
  color: #333;
}
.room-item .room-item-user-status {
  position: absolute;
  top: 17px;
  left: 5px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-block;
  background-color: #999;
}
.room-item .room-item-user-status.in-room {
  background-color: #27ae60;
}
.room-item .room-item-user-media-status {
  justify-content: end;
}
.room-item .room-item-user-media-status > .anticon {
  margin-left: 5px;
}
.room-item .room-item-user-back-btn {
  margin-left: 8px;
  color: #f39c12;
}`, "",{"version":3,"sources":["webpack://./src/feature/subsession/component/subsession-item.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;EACA,sBAAA;EACA,gBAAA;AACF;AAAE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AAEJ;AADI;EACE,mCAAA;AAGN;AADI;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAGN;AAFM;EACE,mBAAA;AAIR;AAFM;EACE,mBAAA;AAIR;AAFM;EACE,mBAAA;AAIR;AAFM;EACE,mBAAA;AAIR;AAFM;EACE,mBAAA;AAIR;AAFM;EACE,mBAAA;AAIR;AAFM;EACE,mBAAA;AAIR;AAFM;EACE,mBAAA;AAIR;AADI;EACE,YAAA;AAGN;AADI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAGN;AADI;EACE,iBAAA;EACA,WAAA;AAGN;AADI;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;AAGN;AAFM;EACE,yBAAA;AAIR;AADI;EACE,oBAAA;AAGN;AAFM;EACE,gBAAA;AAIR;AADI;EACE,gBAAA;EACA,cAAA;AAGN","sourcesContent":[".room-item {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  flex-direction: column;\n  min-height: 30px;\n  .room-item-user {\n    height: 40px;\n    display: flex;\n    align-items: center;\n    position: relative;\n    overflow: hidden;\n    cursor: grab;\n    padding: 0 18px;\n    &:hover {\n      background: rgba(82, 82, 128, 0.09);\n    }\n    &-color-avatar {\n      font-size: 14px;\n      color: #fff;\n      text-align: center;\n      width: 26px;\n      height: 26px;\n      line-height: 26px;\n      box-sizing: border-box;\n      padding: 0 5px;\n      font-weight: 700;\n      margin-right: 8px;\n      border-radius: 20%;\n      &.avatar1 {\n        background: #27ae60;\n      }\n      &.avatar2 {\n        background: #16a085;\n      }\n      &.avatar3 {\n        background: #2980b9;\n      }\n      &.avatar4 {\n        background: #8e44ad;\n      }\n      &.avatar5 {\n        background: #34495e;\n      }\n      &.avatar6 {\n        background: #f39c12;\n      }\n      &.avatar7 {\n        background: #d35400;\n      }\n      &.avatar8 {\n        background: #c0392b;\n      }\n    }\n    &-title{\n      flex-grow: 1;\n    }\n    &-avatar {\n      max-width: 26px;\n      max-height: 26px;\n      margin-right: 8px;\n    }\n    &-name {\n      line-height: 30px;\n      color: #333;\n    }\n    &-status {\n      position: absolute;\n      top: 17px;\n      left: 5px;\n      width: 6px;\n      height: 6px;\n      border-radius: 50%;\n      display: inline-block;\n      background-color: #999;\n      &.in-room {\n        background-color: #27ae60;\n      }\n    }\n    &-media-status{\n      justify-content: end;\n      &>.anticon {\n        margin-left: 5px;\n      }\n    }\n    &-back-btn {\n      margin-left: 8px;\n      color: #f39c12;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
